import React, { useEffect, useState } from "react";
import Header from "../../components/header/Header";
import "./PokemonPage.css";

// ======================================================
// TYPES
// ======================================================

const TYPE_COLORS = {
  normal: "#919191",
  fire: "#E64A19",
  water: "#0288D1",
  grass: "#2E7D32",
  electric: "#F59E0B",
  ice: "#00ACC1",
  fighting: "#C62828",
  poison: "#6A1B9A",
  ground: "#D84315",
  flying: "#0288D1",
  psychic: "#AD1457",
  bug: "#558B2F",
  rock: "#795548",
  ghost: "#4A148C",
  dragon: "#283593",
  steel: "#607D8B",
  dark: "#374151",
  fairy: "#C2185B"
};

const TYPE_NAMES = {
  normal: "Normal",
  fire: "Feu",
  water: "Eau",
  grass: "Plante",
  electric: "Électrik",
  ice: "Glace",
  fighting: "Combat",
  poison: "Poison",
  ground: "Sol",
  flying: "Vol",
  psychic: "Psy",
  bug: "Insecte",
  rock: "Roche",
  ghost: "Spectre",
  dragon: "Dragon",
  steel: "Acier",
  dark: "Ténèbres",
  fairy: "Fée"
};

const STAT_NAMES = {
  hp: "PV",
  attack: "Attaque",
  defense: "Défense",
  specialattack: "Att. Spé.",
  specialdefense: "Déf. Spé.",
  speed: "Vitesse"
};

// ======================================================
// DRESSEURS
// ======================================================

const TRAINERS_BY_TYPE = {
  normal: {
    name: "Norman",
    title: "Champion d'Arène",
    specialty: "Normal",
    region: "Hoenn",
    signaturePokemon: "Monaflèmit",
    badge: "Badge Balancier",
    avatarUrl: "https://play.pokemonshowdown.com/sprites/trainers/norman.png",
    traits: "Champion de Clémenti-Ville, connu pour son style de combat rigoureux."
  },
  fire: {
    name: "Red",
    title: "Dresseur légendaire",
    specialty: "Feu / Polyvalent",
    region: "Kanto",
    signaturePokemon: "Dracaufeu",
    badge: "Dresseur légendaire",
    avatarUrl: "https://play.pokemonshowdown.com/sprites/trainers/red.png",
    traits: "Dresseur silencieux et extrêmement expérimenté."
  },
  water: {
    name: "Ondine",
    title: "Championne d'Arène",
    specialty: "Eau",
    region: "Kanto",
    signaturePokemon: "Starmie",
    badge: "Badge Cascade",
    avatarUrl: "https://play.pokemonshowdown.com/sprites/trainers/misty.png",
    traits: "Championne d'Azuria spécialisée dans les Pokémon de type Eau."
  },
  grass: {
    name: "Erika",
    title: "Championne d'Arène",
    specialty: "Plante",
    region: "Kanto",
    signaturePokemon: "Rafflesia",
    badge: "Badge Prisme",
    avatarUrl: "https://play.pokemonshowdown.com/sprites/trainers/erika.png",
    traits: "Championne élégante spécialisée dans les Pokémon Plante."
  },
  electric: {
    name: "Sacha",
    title: "Dresseur Pokémon",
    specialty: "Électrik / Polyvalent",
    region: "Kanto",
    signaturePokemon: "Pikachu",
    badge: "Maître Pokémon",
    avatarUrl: "https://play.pokemonshowdown.com/sprites/trainers/ash.png",
    traits: "Dresseur aventureux dont Pikachu est le partenaire emblématique."
  },
  ice: {
    name: "Gladys",
    title: "Championne d'Arène",
    specialty: "Glace",
    region: "Sinnoh",
    signaturePokemon: "Blizzaroi",
    badge: "Badge Glaçon",
    avatarUrl: "https://play.pokemonshowdown.com/sprites/trainers/candice.png",
    traits: "Championne de Frimapic spécialisée dans les Pokémon Glace."
  },
  fighting: {
    name: "Bruno",
    title: "Conseil 4",
    specialty: "Combat",
    region: "Kanto / Johto",
    signaturePokemon: "Mackogneur",
    badge: "Conseil 4",
    avatarUrl: "https://play.pokemonshowdown.com/sprites/trainers/bruno.png",
    traits: "Combattant discipliné privilégiant la puissance physique."
  },
  poison: {
    name: "Koga",
    title: "Champion / Conseil 4",
    specialty: "Poison",
    region: "Kanto",
    signaturePokemon: "Grotadmorv",
    badge: "Badge Âme",
    avatarUrl: "https://play.pokemonshowdown.com/sprites/trainers/koga.png",
    traits: "Maître ninja utilisant les altérations de statut."
  },
  ground: {
    name: "Giovanni",
    title: "Boss de la Team Rocket",
    specialty: "Sol",
    region: "Kanto",
    signaturePokemon: "Rhinastoc",
    badge: "Badge Terre",
    avatarUrl: "https://play.pokemonshowdown.com/sprites/trainers/giovanni.png",
    traits: "Dresseur puissant et dirigeant de la Team Rocket."
  },
  flying: {
    name: "Alizée",
    title: "Championne d'Arène",
    specialty: "Vol",
    region: "Hoenn",
    signaturePokemon: "Hélédelle",
    badge: "Badge Plume",
    avatarUrl: "https://play.pokemonshowdown.com/sprites/trainers/winona.png",
    traits: "Championne de Cimetronelle spécialisée dans les Pokémon Vol."
  },
  psychic: {
    name: "Morgane",
    title: "Championne d'Arène",
    specialty: "Psy",
    region: "Kanto",
    signaturePokemon: "Alakazam",
    badge: "Badge Marais",
    avatarUrl: "https://play.pokemonshowdown.com/sprites/trainers/sabrina.png",
    traits: "Championne de Safrania connue pour ses capacités psychiques."
  },
  bug: {
    name: "Artie",
    title: "Champion d'Arène",
    specialty: "Insecte",
    region: "Unys",
    signaturePokemon: "Manternel",
    badge: "Badge Elytre",
    avatarUrl: "https://play.pokemonshowdown.com/sprites/trainers/burgh.png",
    traits: "Champion de Volucité et artiste passionné par les Pokémon Insecte."
  },
  rock: {
    name: "Pierre",
    title: "Champion d'Arène",
    specialty: "Roche",
    region: "Kanto",
    signaturePokemon: "Onix",
    badge: "Badge Roche",
    avatarUrl: "https://play.pokemonshowdown.com/sprites/trainers/brock.png",
    traits: "Champion d'Argenta et éleveur particulièrement attaché à ses Pokémon."
  },
  ghost: {
    name: "Agatha",
    title: "Conseil 4",
    specialty: "Spectre",
    region: "Kanto",
    signaturePokemon: "Ectoplasma",
    badge: "Conseil 4",
    avatarUrl: "https://play.pokemonshowdown.com/sprites/trainers/agatha.png",
    traits: "Ancienne rivale du Professeur Chen."
  },
  dragon: {
    name: "Peter",
    title: "Maître de la Ligue",
    specialty: "Dragon",
    region: "Kanto / Johto",
    signaturePokemon: "Dracolosse",
    badge: "Maître de la Ligue",
    avatarUrl: "https://play.pokemonshowdown.com/sprites/trainers/lance.png",
    traits: "Maître de la Ligue spécialisé dans les Pokémon Dragon."
  },
  steel: {
    name: "Pierre Rochard",
    title: "Maître de la Ligue",
    specialty: "Acier / Roche",
    region: "Hoenn",
    signaturePokemon: "Métalosse",
    badge: "Maître de la Ligue",
    avatarUrl: "https://play.pokemonshowdown.com/sprites/trainers/steven.png",
    traits: "Passionné par les minéraux et spécialiste des Pokémon Acier."
  },
  dark: {
    name: "Pieris",
    title: "Conseil 4",
    specialty: "Ténèbres",
    region: "Unys",
    signaturePokemon: "Scalproie",
    badge: "Conseil 4",
    avatarUrl: "https://play.pokemonshowdown.com/sprites/trainers/grimsley.png",
    traits: "Dresseur élégant utilisant des stratégies basées sur le risque."
  },
  fairy: {
    name: "Valériane",
    title: "Championne d'Arène",
    specialty: "Fée",
    region: "Kalos",
    signaturePokemon: "Nymphali",
    badge: "Badge Nymphe",
    avatarUrl: "https://play.pokemonshowdown.com/sprites/trainers/valerie.png",
    traits: "Championne de Romant-sous-Bois et styliste passionnée."
  },
  default: {
    name: "Cynthia",
    title: "Maître de la Ligue",
    specialty: "Polyvalent",
    region: "Sinnoh",
    signaturePokemon: "Carchacrok",
    badge: "Maître de la Ligue",
    avatarUrl: "https://play.pokemonshowdown.com/sprites/trainers/cynthia.png",
    traits: "Archéologue et dresseuse extrêmement expérimentée."
  }
};

// ======================================================
// OUTILS
// ======================================================

const formatName = name => {
  if (!name) return "";

  return name
    .split("-")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

const getImage = pokemon =>
  pokemon?.sprites?.other?.["official-artwork"]?.front_default ||
  pokemon?.sprites?.other?.home?.front_default ||
  pokemon?.sprites?.front_default;

const getTotalStats = pokemon =>
  pokemon?.stats?.reduce((total, stat) => total + stat.base_stat, 0) || 0;

const getIdFromUrl = url =>
  url?.split("/").filter(Boolean).pop();

const getTrainer = pokemon =>
  TRAINERS_BY_TYPE[pokemon?.types?.[0]?.type?.name] ||
  TRAINERS_BY_TYPE.default;

// ======================================================
// COMPOSANT CARTE POKEMON
// ======================================================

const PokemonCard = ({ pokemon, onClick }) => (
  <div className="pokemon-card" onClick={() => onClick(pokemon)}>

    <img src={getImage(pokemon)} alt={pokemon.name} />

    <h3>{formatName(pokemon.name)}</h3>

    <div className="types">
      {pokemon.types.map(type => (
        <span
          key={type.type.name}
          style={{ backgroundColor: TYPE_COLORS[type.type.name] }}
        >
          {TYPE_NAMES[type.type.name]}
        </span>
      ))}
    </div>
  </div>
);

// ======================================================
// CARTE D'EVOLUTION
// ======================================================

const EvolutionCard = ({ node, pokemonMap, stage = 1 }) => {
  const id = getIdFromUrl(node.species.url);
  const pokemon = pokemonMap[id];

  if (!pokemon) {
    return (
      <div className="evolution-small-card">
        <strong>{formatName(node.species.name)}</strong>
      </div>
    );
  }

  return (
    <div className="evolution-small-card">
      <small>STAGE {stage}</small>

      <img src={getImage(pokemon)} alt={pokemon.name} />

      <strong>{formatName(pokemon.name)}</strong>

      <div className="types">
        {pokemon.types.map(type => (
          <span
            key={type.type.name}
            style={{ backgroundColor: TYPE_COLORS[type.type.name] }}
          >
            {TYPE_NAMES[type.type.name]}
          </span>
        ))}
      </div>
    </div>
  );
};

// ======================================================
// AFFICHAGE D'UNE LIGNEE
// ======================================================

const EvolutionTree = ({ node, pokemonMap, stage = 1 }) => {
  const evolutions = node.evolves_to || [];

  return (
    <div className="evolution-tree">
      <EvolutionCard
        node={node}
        pokemonMap={pokemonMap}
        stage={stage}
      />

      {evolutions.length > 0 && (
        <>
          <div className="evolution-arrow">→</div>

          <div className="evolution-branches">
            {evolutions.map(evolution => (
              <EvolutionTree
                key={evolution.species.name}
                node={evolution}
                pokemonMap={pokemonMap}
                stage={stage + 1}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
};

// ======================================================
// GROUPE EVOLUTION
// ======================================================

const EvolutionGroup = ({ chain, pokemonMap, number }) => {
  const root = chain.chain;

  return (
    <div className="evolution-group">
      <div className="group-header">
        <div>
          <span>GROUPE #{String(number).padStart(3, "0")}</span>
          <h2>Lignée {formatName(root.species.name)}</h2>
        </div>

        <div className="group-count">
          Pokémon liés
        </div>
      </div>

      <div className="evolution-content">
        <EvolutionTree
          node={root}
          pokemonMap={pokemonMap}
        />
      </div>
    </div>
  );
};

// ======================================================
// MODAL
// ======================================================

const PokemonModal = ({
  pokemon,
  species,
  evolutionChain,
  loading,
  onClose,
  pokemonMap
}) => {
  if (!pokemon) return null;

  const trainer = getTrainer(pokemon);

  return (
    <div className="modal-background" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()}>
        <button className="close-button" onClick={onClose}>
          ✕
        </button>

        {/* HERO */}

        <section className="modal-hero">
          <div className="hero-image">
            <img src={getImage(pokemon)} alt={pokemon.name} />
          </div>

          <div>

            <h2>{formatName(pokemon.name)}</h2>

            <div className="types">
              {pokemon.types.map(type => (
                <span
                  key={type.type.name}
                  style={{ backgroundColor: TYPE_COLORS[type.type.name] }}
                >
                  {TYPE_NAMES[type.type.name]}
                </span>
              ))}
            </div>

            <p>
              Découvrez les statistiques, caractéristiques biologiques,
              talents, capacités et évolutions de ce Pokémon.
            </p>
          </div>
        </section>

        {/* INFORMATIONS */}

        <section className="info-grid">
          <InfoItem label="Taille" value={`${(pokemon.height / 10).toFixed(1)} m`} />
          <InfoItem label="Poids" value={`${(pokemon.weight / 10).toFixed(1)} kg`} />
          <InfoItem label="Expérience" value={pokemon.base_experience || "—"} />
          <InfoItem label="Total stats" value={getTotalStats(pokemon)} />
          <InfoItem label="Capacités" value={pokemon.moves?.length || 0} />
        </section>

        {/* STATS */}

        <section className="modal-section">
          <h3>Statistiques de base</h3>

          {pokemon.stats.map(stat => {
            const percentage = Math.min(
              100,
              (stat.base_stat / 150) * 100
            );

            return (
              <div className="stat" key={stat.stat.name}>
                <div className="stat-title">
                  <span>
                    {STAT_NAMES[stat.stat.name] || formatName(stat.stat.name)}
                  </span>
                  <strong>{stat.base_stat}</strong>
                </div>

                <div className="stat-bar">
                  <div style={{ width: `${percentage}%` }} />
                </div>
              </div>
            );
          })}
        </section>

        {/* TALENTS */}

        <section className="modal-section">
          <h3>✨ Talents</h3>

          <div className="ability-list">
            {pokemon.abilities.map(ability => (
              <div className="ability" key={ability.ability.name}>
                {formatName(ability.ability.name)}

                {ability.is_hidden && (
                  <span> CACHÉ</span>
                )}
              </div>
            ))}
          </div>
        </section>

        {/* BIOLOGIE */}

        {species && (
          <section className="modal-section">
            <h3>🧬 Informations biologiques</h3>

            <div className="info-grid">
              <InfoItem
                label="Couleur"
                value={formatName(species.color?.name)}
              />

              <InfoItem
                label="Habitat"
                value={
                  species.habitat
                    ? formatName(species.habitat.name)
                    : "Inconnu"
                }
              />

              <InfoItem
                label="Taux de capture"
                value={species.capture_rate}
              />

              <InfoItem
                label="Bonheur"
                value={species.base_happiness}
              />

              <InfoItem
                label="Croissance"
                value={
                  species.growth_rate
                    ? formatName(species.growth_rate.name)
                    : "—"
                }
              />

              <InfoItem
                label="Génération"
                value={
                  species.generation
                    ? formatName(species.generation.name)
                    : "—"
                }
              />

              <InfoItem
                label="Groupes d'œufs"
                value={
                  species.egg_groups
                    ?.map(group => formatName(group.name))
                    .join(", ")
                }
              />

              <InfoItem
                label="Genre"
                value={
                  species.gender_rate === -1
                    ? "Asexué"
                    : species.gender_rate != null
                    ? `${((8 - species.gender_rate) / 8) * 100}% ♂ / ${(species.gender_rate / 8) * 100}% ♀`
                    : "—"
                }
              />
            </div>
          </section>
        )}

        {/* EVOLUTION */}

        {loading ? (
          <div className="loading-details">
            Chargement des évolutions...
          </div>
        ) : evolutionChain ? (
          <section className="modal-section">
            <h3>🔄 Chaîne d'évolution</h3>

            <div className="modal-evolution">
              <EvolutionTree
                node={evolutionChain.chain}
                pokemonMap={pokemonMap}
              />
            </div>
          </section>
        ) : null}

        {/* CAPACITES */}

        <section className="modal-section">
          <h3>⚔️ Capacités disponibles</h3>

          <p>
            Ce Pokémon possède{" "}
            <strong>{pokemon.moves?.length || 0}</strong> capacités
            référencées.
          </p>

          <div className="moves">
            {pokemon.moves?.slice(0, 40).map(move => (
              <span key={move.move.name}>
                {formatName(move.move.name)}
              </span>
            ))}
          </div>
        </section>

        {/* DRESSEUR */}

        <section className="trainer">
          <img src={trainer.avatarUrl} alt={trainer.name} />

          <div>
            <small>DRESSEUR EMBLÉMATIQUE</small>
            <h3>{trainer.name}</h3>
            <strong>{trainer.title}</strong>
            <p>{trainer.traits}</p>
          </div>

          <div>
            <small>SPÉCIALITÉ</small>
            <strong>{trainer.specialty}</strong>

            <small>RÉGION</small>
            <strong>{trainer.region}</strong>
          </div>
        </section>
      </div>
    </div>
  );
};

// ======================================================
// PETIT COMPOSANT INFO
// ======================================================

const InfoItem = ({ label, value }) => (
  <div className="info-item">
    <small>{label}</small>
    <strong>{value || "—"}</strong>
  </div>
);

// ======================================================
// PAGE PRINCIPALE
// ======================================================

const PokemonPage = () => {
  const [allPokemons, setAllPokemons] = useState([]);
  const [evolutionGroups, setEvolutionGroups] = useState([]);

  const [loading, setLoading] = useState(true);
  const [loadingEvolution, setLoadingEvolution] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const [selectedType, setSelectedType] = useState("");

  const [viewMode, setViewMode] = useState("evolution");

  const [selectedPokemon, setSelectedPokemon] = useState(null);
  const [speciesData, setSpeciesData] = useState(null);
  const [selectedEvolution, setSelectedEvolution] = useState(null);
  const [loadingDetails, setLoadingDetails] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);

  // 20 GROUPES PAR PAGE
  const itemsPerPage = 20;

  // ======================================================
  // CHARGER LES POKEMON
  // ======================================================

  useEffect(() => {
    const loadPokemons = async () => {
      try {
        setLoading(true);

        const response = await fetch(
          "https://pokeapi.co/api/v2/pokemon?limit=1351"
        );

        const data = await response.json();

        const results = [];

        // On travaille par groupes de 20
        for (let i = 0; i < data.results.length; i += 20) {
          const batch = data.results.slice(i, i + 20);

          const pokemonData = await Promise.all(
            batch.map(async pokemon => {
              try {
                const response = await fetch(pokemon.url);

                if (!response.ok) return null;

                return await response.json();
              } catch {
                return null;
              }
            })
          );

          results.push(...pokemonData.filter(Boolean));

          setAllPokemons([...results]);
        }
      } catch (error) {
        console.error("Erreur Pokémon :", error);
      } finally {
        setLoading(false);
      }
    };

    loadPokemons();
  }, []);

  // ======================================================
  // CHARGER LES CHAÎNES D'EVOLUTION
  // ======================================================

  useEffect(() => {
    if (allPokemons.length === 0) return;

    const loadEvolutionGroups = async () => {
      try {
        setLoadingEvolution(true);

        const chains = {};
        const speciesCache = {};

        // On récupère les espèces
        for (let i = 0; i < allPokemons.length; i += 20) {
          const batch = allPokemons.slice(i, i + 20);

          const speciesResults = await Promise.all(
            batch.map(async pokemon => {
              try {
                if (speciesCache[pokemon.species.url]) {
                  return speciesCache[pokemon.species.url];
                }

                const response = await fetch(pokemon.species.url);

                if (!response.ok) return null;

                const species = await response.json();

                speciesCache[pokemon.species.url] = species;

                return species;
              } catch {
                return null;
              }
            })
          );

          speciesResults.filter(Boolean).forEach(species => {
            if (species.evolution_chain?.url) {
              chains[species.evolution_chain.url] = true;
            }
          });
        }

        // Maintenant on récupère chaque vraie chaîne
        const chainUrls = Object.keys(chains);
        const groups = [];

        for (let i = 0; i < chainUrls.length; i += 20) {
          const batch = chainUrls.slice(i, i + 20);

          const chainResults = await Promise.all(
            batch.map(async url => {
              try {
                const response = await fetch(url);

                if (!response.ok) return null;

                return await response.json();
              } catch {
                return null;
              }
            })
          );

          groups.push(...chainResults.filter(Boolean));
        }

        setEvolutionGroups(groups);
      } catch (error) {
        console.error("Erreur évolutions :", error);
      } finally {
        setLoadingEvolution(false);
      }
    };

    loadEvolutionGroups();
  }, [allPokemons]);

  // ======================================================
  // MAP DES POKEMON
  // ======================================================

  const pokemonMap = {};

  allPokemons.forEach(pokemon => {
    pokemonMap[pokemon.id] = pokemon;
  });

  // ======================================================
  // TYPES
  // ======================================================

  const types = Object.keys(TYPE_NAMES);

  // ======================================================
  // FILTRE LISTE
  // ======================================================

  const filteredPokemons = allPokemons.filter(pokemon => {
    const name = pokemon.name.toLowerCase();
    const search = searchTerm.toLowerCase();

    const matchName = name.includes(search);

    const matchType =
      !selectedType ||
      pokemon.types.some(
        type => type.type.name === selectedType
      );

    return matchName && matchType;
  });

  // ======================================================
  // FILTRE EVOLUTION
  // ======================================================

  const filteredEvolutionGroups = evolutionGroups.filter(group => {
    if (!searchTerm && !selectedType) return true;

    const rootName = group.chain.species.name
      .toLowerCase()
      .includes(searchTerm.toLowerCase());

    if (rootName) return true;

    const findPokemon = node => {
      if (
        node.species.name
          .toLowerCase()
          .includes(searchTerm.toLowerCase())
      ) {
        return true;
      }

      return node.evolves_to?.some(findPokemon);
    };

    return findPokemon(group.chain);
  });

  // ======================================================
  // PAGINATION
  // ======================================================

  const currentData =
    viewMode === "evolution"
      ? filteredEvolutionGroups
      : filteredPokemons;

  const totalPages =
    Math.ceil(currentData.length / itemsPerPage) || 1;

  const startIndex = (currentPage - 1) * itemsPerPage;

  const currentItems = currentData.slice(
    startIndex,
    startIndex + itemsPerPage
  );

  // ======================================================
  // RESET PAGE
  // ======================================================

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, selectedType, viewMode]);

  // ======================================================
  // OUVRIR MODAL
  // ======================================================

  const openPokemon = async pokemon => {
    setSelectedPokemon(pokemon);
    setSpeciesData(null);
    setSelectedEvolution(null);
    setLoadingDetails(true);

    try {
      const response = await fetch(pokemon.species.url);

      if (!response.ok) throw new Error();

      const species = await response.json();

      setSpeciesData(species);

      if (species.evolution_chain?.url) {
        const evolutionResponse = await fetch(
          species.evolution_chain.url
        );

        if (evolutionResponse.ok) {
          const evolution = await evolutionResponse.json();
          setSelectedEvolution(evolution);
        }
      }
    } catch (error) {
      console.error("Erreur détails :", error);
    } finally {
      setLoadingDetails(false);
    }
  };

  // ======================================================
  // RENDU
  // ======================================================

  return (
    <>
      <Header />

      <main className="pokemon-page">
        <div className="pokemon-container">

          {/* HEADER */}

          <header className="page-header">
            <div>
              <span className="subtitle">
                Encyclopédie Pokémon
              </span>

              <h1>⚡ PokéWarm Explorer</h1>

              <p>
                Explorez les Pokémon, leurs statistiques,
                caractéristiques, capacités et évolutions.
              </p>
            </div>

            <div className="statistics">
              <div>
                <small>POKÉMON</small>
                <strong>{allPokemons.length}</strong>
              </div>

              <div>
                <small>
                  {viewMode === "evolution"
                    ? "LIGNÉES"
                    : "RÉSULTATS"}
                </small>

                <strong>{currentData.length}</strong>
              </div>
            </div>
          </header>

          {/* RECHERCHE */}

          <section className="search-box">
            <input
              type="text"
              placeholder="🔎 Rechercher un Pokémon..."
              value={searchTerm}
              onChange={e => setSearchTerm(e.target.value)}
            />

            <select
              value={selectedType}
              onChange={e => setSelectedType(e.target.value)}
            >
              <option value="">Tous les types</option>

              {types.map(type => (
                <option key={type} value={type}>
                  {TYPE_NAMES[type]}
                </option>
              ))}
            </select>

            {(searchTerm || selectedType) && (
              <button
                onClick={() => {
                  setSearchTerm("");
                  setSelectedType("");
                }}
              >
                Réinitialiser
              </button>
            )}
          </section>

          {/* MODES */}

          <div className="view-buttons">
            <button
              className={
                viewMode === "evolution" ? "active" : ""
              }
              onClick={() => setViewMode("evolution")}
            >
              ⭐ Par évolution
            </button>

            <button
              className={
                viewMode === "list" ? "active" : ""
              }
              onClick={() => setViewMode("list")}
            >
              ▦ Par liste
            </button>
          </div>

          {/* PAGINATION HAUT */}

          {!loading &&
            !loadingEvolution &&
            currentData.length > 0 && (
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                startIndex={startIndex}
                count={currentData.length}
                itemsPerPage={itemsPerPage}
                setCurrentPage={setCurrentPage}
              />
            )}

          {/* CHARGEMENT */}

          {(loading || loadingEvolution) && (
            <div className="loading">
              <div>⚡</div>
              <h2>
                {loading
                  ? "Chargement du PokéWarm..."
                  : "Construction des lignées..."}
              </h2>

              <p>
                Récupération des données Pokémon.
              </p>
            </div>
          )}

          {/* ==================================================
              MODE EVOLUTION
          ================================================== */}

          {!loading &&
            !loadingEvolution &&
            viewMode === "evolution" && (
              <>
                {currentItems.length === 0 ? (
                  <Empty />
                ) : (
                  <div className="evolution-grid">
                    {currentItems.map((group, index) => (
                      <EvolutionGroup
                        key={group.id}
                        chain={group}
                        pokemonMap={pokemonMap}
                        number={startIndex + index + 1}
                      />
                    ))}
                  </div>
                )}
              </>
            )}

          {/* ==================================================
              MODE LISTE
          ================================================== */}

          {!loading &&
            viewMode === "list" && (
              <>
                {currentItems.length === 0 ? (
                  <Empty />
                ) : (
                  <div className="pokemon-grid">
                    {currentItems.map(pokemon => (
                      <PokemonCard
                        key={pokemon.id}
                        pokemon={pokemon}
                        onClick={openPokemon}
                      />
                    ))}
                  </div>
                )}
              </>
            )}

          {/* PAGINATION BAS */}

          {!loading &&
            !loadingEvolution &&
            currentData.length > 0 && (
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                startIndex={startIndex}
                count={currentData.length}
                itemsPerPage={itemsPerPage}
                setCurrentPage={setCurrentPage}
              />
            )}
        </div>
      </main>

      {/* MODAL */}

      {selectedPokemon && (
        <PokemonModal
          pokemon={selectedPokemon}
          species={speciesData}
          evolutionChain={selectedEvolution}
          loading={loadingDetails}
          onClose={() => setSelectedPokemon(null)}
          pokemonMap={pokemonMap}
        />
      )}
    </>
  );
};

// ======================================================
// PAGINATION
// ======================================================

const Pagination = ({
  currentPage,
  totalPages,
  startIndex,
  count,
  itemsPerPage,
  setCurrentPage
}) => (
  <div className="pagination">

    <span>
      Affichage{" "}
      <strong>{startIndex + 1}</strong>
      {" "}à{" "}
      <strong>
        {Math.min(startIndex + itemsPerPage, count)}
      </strong>
      {" "}sur{" "}
      <strong>{count}</strong>
    </span>

    <div>
      <button
        disabled={currentPage === 1}
        onClick={() =>
          setCurrentPage(page => Math.max(1, page - 1))
        }
      >
        ←
      </button>

      <span>
        Page <strong>{currentPage}</strong> / {totalPages}
      </span>

      <button
        disabled={currentPage === totalPages}
        onClick={() =>
          setCurrentPage(page =>
            Math.min(totalPages, page + 1)
          )
        }
      >
        →
      </button>
    </div>
  </div>
);

// ======================================================
// AUCUN RESULTAT
// ======================================================

const Empty = () => (
  <div className="empty">
    <div>🔎</div>
    <h3>Aucun Pokémon trouvé</h3>
    <p>Essayez un autre nom ou un autre type.</p>
  </div>
);

export default PokemonPage;